export type DiffSegment = { type: 'equal' | 'add' | 'remove'; text: string };

function tokenize(s: string): string[] {
    // Split on whitespace runs, keeping the separators so the original string can be reconstructed.
    return s.split(/(\s+)/);
}

function pushSeg(arr: DiffSegment[], type: DiffSegment['type'], text: string): void {
    const last = arr[arr.length - 1];
    if (last && last.type === type) {
        last.text += text;
    } else {
        arr.push({ type, text });
    }
}

// Word-level LCS diff. O(m*n) — fine for ~500-token posts; don't feed it novels.
export function wordDiff(original: string, corrected: string): DiffSegment[] {
    const A = tokenize(original);
    const B = tokenize(corrected);
    const m = A.length;
    const n = B.length;

    const dp: number[][] = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
    for (let i = m - 1; i >= 0; i--) {
        for (let j = n - 1; j >= 0; j--) {
            if (A[i] === B[j]) dp[i][j] = dp[i + 1][j + 1] + 1;
            else dp[i][j] = Math.max(dp[i + 1][j], dp[i][j + 1]);
        }
    }

    const segs: DiffSegment[] = [];
    let i = 0;
    let j = 0;
    while (i < m && j < n) {
        if (A[i] === B[j]) { pushSeg(segs, 'equal', A[i]); i++; j++; }
        else if (dp[i + 1][j] >= dp[i][j + 1]) { pushSeg(segs, 'remove', A[i]); i++; }
        else { pushSeg(segs, 'add', B[j]); j++; }
    }
    while (i < m) pushSeg(segs, 'remove', A[i++]);
    while (j < n) pushSeg(segs, 'add', B[j++]);

    return segs;
}
